import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Lilate, LilateStatus } from '../../../../../shared/src/lib/model/lilate.model';
import { LilateActionTypes } from '../../../../../shared/src/lib/store/actions/lilate.actions';
import * as lilateActions from '../../../../../shared/src/lib/store/actions/lilate.actions';
import { LilateService } from '../../../../../shared/src/lib/service/lilate.service';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { assessmentResult, lilateGrid } from '../../../../../shared/src/lib/model/assessment.model';
import * as $ from 'jquery';
import { ProfilePhotosService } from '../../../../../shared/src/lib/service/profilePhotos.service';
import { MaterialService } from '../../../../../shared/src/lib/service/material.service';
@Component({
  selector: 'app-assessment-lilate',
  templateUrl: './assessment-lilate.component.html',
  styleUrls: ['./assessment-lilate.component.scss']
})
export class AssessmentLilateComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  grid: lilateGrid[];
  treeInfos = [];
  treeResult = {
    lilate: null,
    mode: 'total',
    assessment: []
  };
  lilate: Lilate;
  globalId: number;

  student_abs: boolean = null;
  identity_issue: boolean = null;
  photo_profile_issue: boolean = null;
  saveProcessing = false;

  constructor(
    private lilateService: LilateService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private materialService: MaterialService,
    private profilePhotosService: ProfilePhotosService
  ) { }

  ngOnInit() {
    if (history.state.data && history.state.data.lilate) {
      this.lilate = history.state.data.lilate;
    } else {
      this.router.navigateByUrl('lilates');
    }

    this.lilateService.getGrid(new HttpParams().append('version', this.lilate.version.id)).subscribe(
      grid => {
        this.grid = grid.results;
        for (let i = 0; i < this.grid.length; i++) {
          if (this.grid[i].slug === 'global-level-assessment') {
            this.globalId = this.grid[i].id;
          }
          this.treeInfos[this.grid[i].id] = { id: null, skills: [] };
        }
      }
    )
  }


  reportIssueLilate() {
    this.lilateService.patch({ status: LilateStatus.abs_student_without_justification }, this.lilate.id).subscribe(
      () => {
        this.goTolist()
      }
    );
  }

  getSkills(id, level, rubriqueId) {
    this.lilateService.getSkills(new HttpParams().append('lilate_grid', id)).subscribe(
      skills => {
        this.treeInfos[rubriqueId].skills = skills.results;
        this.treeInfos[rubriqueId].id = id;
        this.treeInfos[rubriqueId].level = level;
        this.treeInfos[rubriqueId].skillSelected = false;
        for (let i = 0; i < this.treeInfos[rubriqueId].skills.length; i++) {
          this.treeInfos[rubriqueId].skills[i].selected = false;
        }
      }
    )
  }

  selectSkill(selectedId, rubriqueId) {
    for (let i = 0; i < this.treeInfos[rubriqueId].skills.length; i++) {
      if (this.treeInfos[rubriqueId].skills[i].id === selectedId) {
        this.treeInfos[rubriqueId].skills[i].selected = !this.treeInfos[rubriqueId].skills[i].selected;
        this.treeInfos[rubriqueId].skillSelected = this.checkIfSkillSelected(rubriqueId);
      }
    }
  }

  checkIfSkillSelected(rubriqueId): boolean {
    for (let i = 0; i < this.treeInfos[rubriqueId].skills.length; i++) {
      if (this.treeInfos[rubriqueId].skills[i].selected === true) {
        return true;
      }
    }
    return false;
  }

  getSkillsResult(skills) {
    const skillsResuls = [];
    for (let i = 0; i < skills.length; i++) {
      skillsResuls.push({ id: skills[i].id, selected: skills[i].selected })
    }
    return skillsResuls;
  }

  postassessment(): void {
    this.saveProcessing = true;
    this.treeResult = {
      lilate: this.lilate.id,
      mode: 'total',
      assessment: []
    };
    if (this.student_abs === null || this.identity_issue === null || this.photo_profile_issue === null) {
      this.materialService.openSnackBar("Check error messages above", 'red')
      this.saveProcessing = false;
      return
    }
    for (let i = 0; i < this.grid.length; i++) {
      if (!this.treeInfos[this.grid[i].id].skillSelected && this.grid[i].slug !== 'global-level-assessment') {
        this.materialService.openSnackBar("Check error messages above", 'red')
        this.saveProcessing = false;
        return
      }
      if (!this.treeInfos[this.grid[i].id].id && this.grid[i].slug === 'global-level-assessment') {
        this.materialService.openSnackBar("Check error messages above (missing global level)", 'red')
        this.saveProcessing = false;
        return
      }
      const result = {
        id: this.treeInfos[this.grid[i].id].id,
        skills: this.getSkillsResult(this.treeInfos[this.grid[i].id].skills)
      }
      this.treeResult.assessment.push(result);
    }
    this.lilateService.postResult(this.treeResult).subscribe({
      next: (assessmentResult: assessmentResult) => {
        if (this.photo_profile_issue) {
          this.updateProfileStatus('refused')
        } else {
          this.updateProfileStatus('validated')
        }
      },
      error: (data: any) => {
        data.error.errors.map(error => this.materialService.openSnackBar(error, 'red'))
      }
    }
    );
  }


  updateProfileStatus(status) {
    const params = {
      status: status,
    };
    this.profilePhotosService.patchProfilePhoto(this.lilate.student.user.photo_profile.id, params).subscribe(
      () => {
        this.lilateService.patch({ identity_issue: this.identity_issue }, this.lilate.id).subscribe(
          () => {
            this.goTolist()
          }
        );
      }
    );
  }

  goTolist() {
    this.router.navigateByUrl('lilates');
    this.materialService.openSnackBar("Your assessment has been saved", 'green')
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  scroll(el: string) {
    document.getElementById(el).scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
